import { Login, useAccountContext } from 'features/auth';

import React from 'react';
import { Navigate, RouteObject, useRoutes } from 'react-router-dom';
import PriceShowList from 'features/price-show/PriceShowList';
import QuotationList from 'features/quotation/QuotationList';
import QuotationDetail from 'features/quotation/QuotationDetail';
import DraftQuotation from 'features/draft-quotation/DraftQuotation';
import MedicineList from 'features/medicine/MedicineList';
import { QuotationDetailRedirect } from './LegacyRedirect';
import {
  LOGIN_PATH,
  QUOTATIONS_PATH,
  MEDICINES_PATH,
  DRAFT_QUOTATIONS_PATH,
  PRICE_SHOW_PATH,
} from './paths';

// パス定数をre-export（互換性のため）
export {
  LOGIN_PATH,
  QUOTATIONS_PATH,
  MEDICINES_PATH,
  DRAFT_QUOTATIONS_PATH,
  PRICE_SHOW_PATH,
} from './paths';

const publicRoutes: RouteObject[] = [
  {
    path: LOGIN_PATH,
    element: <Login />,
  },
  // 旧パスから新パスへのリダイレクト
  {
    path: '/login',
    element: <Navigate to={LOGIN_PATH} replace />,
  },
  {
    path: '*',
    element: <Navigate to={LOGIN_PATH} />,
  },
];

export const userRoutes: RouteObject[] = [
  {
    path: PRICE_SHOW_PATH,
    element: <PriceShowList />,
  },
  {
    path: QUOTATIONS_PATH,
    element: <QuotationList />,
  },
  {
    path: `${QUOTATIONS_PATH}/:id`,
    element: <QuotationDetail />,
  },
  {
    path: MEDICINES_PATH,
    element: <MedicineList />,
  },
  {
    path: DRAFT_QUOTATIONS_PATH,
    element: <DraftQuotation />,
  },
  // 旧パスから新パスへのリダイレクト
  {
    path: '/price-show',
    element: <Navigate to={PRICE_SHOW_PATH} replace />,
  },
  {
    path: '/quotations',
    element: <Navigate to={QUOTATIONS_PATH} replace />,
  },
  {
    path: '/quotations/:id',
    element: <QuotationDetailRedirect />,
  },
  {
    path: '/medicines',
    element: <Navigate to={MEDICINES_PATH} replace />,
  },
  {
    path: '/draft-quotation',
    element: <Navigate to={DRAFT_QUOTATIONS_PATH} replace />,
  },
  {
    path: '*',
    element: <Navigate to={PRICE_SHOW_PATH} />,
  },
];

export const AppRoutes: React.FC = () => {
  const accountContext = useAccountContext();
  let routes = publicRoutes;
  if (accountContext.account !== undefined) {
    routes = userRoutes;
  }
  const element = useRoutes(routes);
  return element;
};
